_removeUserProfileImages